var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('h2',[_vm._v("Oops")]),_c('p',[_vm._v(_vm._s(_vm.$t('global.common.pageError')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }